import React, { useState, useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table,Spinner,Form } from "react-bootstrap";
import { routes } from '../routes/routes-names';
import { Link, useNavigate } from "react-router-dom";
import { RegPayDetailsFormType } from "../types/common";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { eventService } from "../lib/api/event";


const STATUS_LABELS: Record<string, string> = {
  pen: "Pending",
  rej: "Rejected",
  ver: "Verified",
  apr: "Approved",
  com: "Completed",
};

const EventViewPayPage: React.FC = () => {
  
 interface AttendanceRespPoint {
  eventDate: string;
  weightage: number;
}
  interface eventType {
  id: number;
  nameOfEvent: string;
  attendanceRespPoints:AttendanceRespPoint[];
  remarks:string;
  eventCategory: string;
  eventType: string;
  department: string;
  speciality: string;
  paymentStatus: string;
  organizationType: string;
  programSheet1: string;
  programSheet2: string;
  programSheet3: string;
  programSheet4: string;
  programSheet5: string;
  letterHost: string;
}


  const navigate = useNavigate();
  const [eventData, setEventData] = useState<eventType[]>([]);
    
   const [isLoader, setIsLoader] = useState(false);

    const [regPayDetails, setRegPayDetails] = useState<RegPayDetailsFormType | null>(null);
    
    const [payUrl, setPayUrl] = useState('');
    const [payOrderId, setPayOrderId] = useState('');
    const [eventId, setEventId] = useState<number>(0);
    const [selectedPaymentEventId, setSelectedPaymentEventId] = useState<number | null>(null);
    
    
  const toggleRow = async (id: number) => {
    setIsLoader(true);
    setEventId(id);
    setSelectedPaymentEventId(id);
    setRegPayDetails(null);
    await getEventRegFeeDetails(id);
  };

    const handleRegiStration =() =>{
      navigate(routes.eventDocInfo);
    }
    const handleFinishAfterAttendance = () => {
      navigate(routes.eventDocInfo, { state: { focusFinish: true } });
    }
const PayAndContinueForm = useCallback(async (payUrl: string, payOrderId: string) => {
        try {
            if (payUrl) {
                  secureLocalStorage.setItem("respOrderKeyId",payOrderId);
                  secureLocalStorage.setItem("eventId",eventId);
                  secureLocalStorage.setItem("regType",'event');
                  window.open(payUrl, '_self', 'noreferrer');
            } else {
                alert("Error in PayAndContinueForm");
            }
        } catch (err) {
            console.log('error in payment process during the provisional registrartion.', err);
        }
    }, [eventId]);

  const getEventRegFeeDetails = useCallback(async (eventId: number) => {
        try {
          
          const orgData =  localStorage.getItem("orgdata");
              if (orgData) {
                  const retrievedObject = JSON.parse(orgData);
                  // Avoid logging sensitive org details
                 const orgPrimaryId=retrievedObject.id;
                 const formData = new FormData();
                 formData.append("orgPrimaryId", JSON.stringify(orgPrimaryId));
                 formData.append("intEventId", JSON.stringify(eventId));
            const provData = await eventService.getEventFeeDetails(formData);
            if (provData.data) {
                setRegPayDetails({
                    registrationFee: provData.data.registrationFee,
                    noOfApprovedDocs: provData.data.noOfApprovedDocs,
                    totalAmount: provData.data.totalAmount,
                    extraCharges: provData.data.extraCharges,
                    fullName: provData.data.fullName,
                    phoneNo: provData.data.mobileNo,
                    address: provData.data.address,
                });
                setPayUrl(provData.data.redirectUrl);
                setPayOrderId(provData.data.orderKeyId);
             
            }
          }

        } catch (err: any) {
            // Avoid logging sensitive error details
        } finally {
            setIsLoader(false);
        }
    }, []);

    const getEventsbyOrgid = useCallback(async () => {
        try {
          const orgData = localStorage.getItem("orgdata");
          if (orgData) {
            const retrievedObject = JSON.parse(orgData);
            const { data } = await eventService.getAllEventsbyOrgid(retrievedObject.id);
            setEventData(data);
          }
        } catch (err) {
          // Avoid logging sensitive error details
        }
      }, []);

   useEffect(() => {
        getEventsbyOrgid();
    }, [getEventsbyOrgid]);
  

  return (
    <div className="org-page">
      <div className="org-container mt-4">
      <h2 className="cme-title">Event Payment Status Details</h2> 
      <Table bordered hover responsive>
        <thead className="table-primary">
          <tr>
            <th>Event Name</th>
            <th>Event Type</th>
            <th>Department</th>
            <th>Status</th>
            <th>Daywise Points</th>
            <th>Actions</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {eventData && eventData.map((event) => (
                      <React.Fragment key={event.id}>
                        <tr>
                          <td>{event.nameOfEvent}</td>
                          <td>{event.eventCategory}</td>
                          <td>{event.eventType}</td>
                          <td>
                    {STATUS_LABELS[event.paymentStatus] ?? STATUS_LABELS[event.paymentStatus?.toLowerCase?.()] ?? event.paymentStatus ?? "--"}
                    </td>
                    <td>
                    {event.paymentStatus !== 'pen' &&
                         <table> 
                          <thead>
                            <tr>
                              <th style={{ width: "50%" }}>Date</th>
                              <th style={{ width: "50%" }}>Points</th>
                            </tr>
                          </thead>
                          <tbody>
                            {event.attendanceRespPoints && event.attendanceRespPoints.length>0 && event.attendanceRespPoints.map((item) => (
                              <tr key={item.eventDate}>
                                <td className="fw-semibold">
                                  {moment(item.eventDate).format("DD-MM-YYYY")}
                                </td>

                                <td>
                                  <Form.Control
                                    type="number"
                                    disabled
                                    min={0}
                                    max={10}
                                    value={item.weightage}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          </table>
                        }

                          </td>
                <td style={{ textAlign: "center" }}>
                  {event.paymentStatus === "ver" && (
                    <div className="d-flex flex-column align-items-center gap-1">
                      <button
                        className="primary-btn btn-sm"
                        style={{ padding: "8px 16px", fontSize: "13px" }}
                        onClick={handleRegiStration}
                      >
                        Record Attendance
                      </button>
                      <button
                        type="button"
                        className="btn btn-link btn-sm text-decoration-underline p-0"
                        onClick={handleFinishAfterAttendance}
                        style={{ fontSize: "12px" }}
                      >
                        Finish after attendance
                      </button>
                    </div>
                  )}

                  {event.paymentStatus === "rej" && (
                    <Link
                      to={`/mainLayout/edit-event/${event.id}`}
                      className="btn btn-primary btn-sm me-3"
                    >
                      Edit
                    </Link>
                  )}

                  {event.paymentStatus === "com" && (
                    <button onClick={() => toggleRow(event.id)}>
                      Click To Pay
                    </button>
                  )}

                  {event.paymentStatus !== "ver" &&
                    event.paymentStatus !== "rej" &&
                    event.paymentStatus !== "com" && <span>--</span>}
                </td>
                

                <td title={event.remarks || ""}>
                    {event.remarks?.trim() || "--"}
                </td>
                        </tr>
                        {selectedPaymentEventId === event.id && regPayDetails && (
                          <tr>
                            <td colSpan={7}>
                              <div className="container mt-2 mb-2 cme-header">
                                <section className="gray-banner">
                                  <div className="col-10 m-auto mt-2">
                                    <div className="card mb-3 shadow border-0">
                                      <div className="card-header">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div>
                                            <h3 className="fs-18 fw-700 mb-0">Payment details</h3>
                                          </div>
                                          <div></div>
                                        </div>
                                      </div>
                                      <div className="card-body">
                                        <div className="d-flex">
                                          <div className="col border-end">
                                            <div className="row mb-3">
                                              <div className="col"><label htmlFor="">Organization Name: </label></div>
                                              <div className="col fs-14">{regPayDetails?.fullName}</div>
                                            </div>
                                            <div className="row mb-3">
                                              <div className="col"><label htmlFor="">Address:</label></div>
                                              <div className="col fs-14">{regPayDetails?.address}</div>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-end ps-2">
                                            <div>
                                              <div className="d-flex align-items-center justify-content-between mb-3">
                                                <label htmlFor="">Registration Fee:</label>
                                                <div className="fs-10"><i className="bi-currency-rupee"></i> {regPayDetails?.registrationFee}/-</div>
                                              </div>
                                              <div className="d-flex align-items-center justify-content-between mb-3">
                                                <label htmlFor="">Approved Doctors:</label>
                                                <div className="fs-10">{regPayDetails?.noOfApprovedDocs}</div>
                                              </div>
                                              <hr />
                                              <div className="d-flex align-items-center justify-content-between mb-3">
                                                <label htmlFor="">Total:</label>
                                                <div className="fs-10"><i className="bi-currency-rupee"></i> {regPayDetails?.totalAmount}/-</div>
                                              </div>
                                              <hr className="mb-0" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="card-footer text-end py-3">
                                        <button type="button" onClick={() => PayAndContinueForm(payUrl, payOrderId)} className="cme-header">Continue & Pay</button>
                                      </div>
                                    </div>
                                    <div className="card shadow border-0 mb-3">
                                      <div className="card-body d-flex justify-content-between align-items-center">
                                        <div className="fs-13 d-flex">
                                          <Link target={'_blank'} className="pe-2" to={'/terms-and-conditions'}>Terms and Conditions</Link>
                                          <Link target={'_blank'} className="px-2" to={'/privacy-policy'}>Privacy Policy</Link>
                                          <Link target={'_blank'} className="ps-2" to={'/refund'}>Refund</Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              </div>
                            </td>
                          </tr>
                        )}
              
              </React.Fragment>
              ))}
              </tbody>
              </Table>

            {isLoader&&   <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" />
      </div>}
  </div>
  </div>
  );
};

export default EventViewPayPage;
